import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';
import { CustomersService } from '../../../../services/customer/customers.service';
import { CountryService } from '../../../../services/country/country.service';
import { ProvinceService } from '../../../../services/province/province.service';
import { CustomerCompanyData } from '../../../../models/customer.model';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-customer-company-address',
  templateUrl: './customer-company-address.component.html',
  styleUrls: ['./customer-company-address.component.css'],
  providers: [CustomersService]
})
export class CustomerCompanyAddressComponent implements OnInit {

  @Input() customerId: string;

  @Output() dirtyFormData = new EventEmitter();

  form: FormGroup;
  countries: SelectItem[];
  provinces: SelectItem[];
  addressTypes: SelectItem[];
  firstAddress: CustomerCompanyData;


  constructor(
    private fb: FormBuilder,
    private countryService: CountryService,
    private provinceService: ProvinceService,
    private companyService: CustomersService,
    private translateService: TranslateService
  ) { }

  get addresses(): FormArray {
    return this.form.get('addresses') as FormArray;
  }

  ngOnInit() {
    this.translateService.get([
      'customerCompany.selectCountry',
      'customerCompany.selectProvince',
      'customerCompany.selectAddressType',
      'customerCompany.addressTypeLegal',
      'customerCompany.addressTypeOperating',
      'customerCompany.addressTypeShipment',
    ]).subscribe(translations => {

      this.companyService.getCompanyData(this.customerId).subscribe(companyData => {
        this.firstAddress = companyData.shift();
        const addresses = [];

        for(let address of companyData) {
          addresses.push(this.fb.group(this.getAddress(address), { updateOn: 'submit' }));
        }

        this.form = this.fb.group({
          addresses: this.fb.array(addresses)
        }, { updateOn: 'submit' });

        this.onChanges();
        
      });


      this.countryService.getAll().subscribe(res => {
        this.countries = [
          { label: translations['customerCompany.selectCountry'], value: null }
        ];
        for(const country of res) {
          this.countries.push({ label: country.name, value: country.id });
        }
      });

      this.provinceService.getAll().subscribe(res => {
        this.provinces = [
          { label: translations['customerCompany.selectProvince'], value: null }
        ];
        for(const province of res) {
          this.provinces.push({ label: province.name, value: province.id });
        }
      });

      this.addressTypes = [
        { label: translations['customerCompany.selectAddressType'], value: null },
        { label: translations['customerCompany.addressTypeLegal'], value: 'A' },
        { label: translations['customerCompany.addressTypeOperating'], value: 'B' },
        { label: translations['customerCompany.addressTypeShipment'], value: 'C' },
      ];
    });
  }

  onChanges(): void {
    this.form.valueChanges.subscribe(() => this.dirtyFormData.emit(this.form.dirty));
  }

  getAddress(address: CustomerCompanyData) {
    return {
      id: address.id || '',
      row_num: address.row_num || '',
      flg_type: [address.flg_type || '', Validators.required],
      company_name: [address.company_name || this.firstAddress.company_name, Validators.required],
      vat_code: [address.vat_code || this.firstAddress.vat_code, Validators.required],
      address: [address.address || '', Validators.required],
      address_number: [address.address_number || '', Validators.required],
      zip_code: [address.zip_code || '', Validators.required],
      country_id: [address.country_id || '', Validators.required],
      province_id: [address.province_id || '', Validators.required],
      city: [address.city || '', Validators.required],
      phone_primary: address.phone_primary || '',
      phone_mobile: address.phone_mobile || '',
      email_primary: address.email_primary || '',
      email_secondary: address.email_secondary || '',
      other_telephone: address.other_telephone || ''
    }
  }

  addAddress() {
    this.addresses.push(
      this.fb.group(
        this.getAddress(new CustomerCompanyData()),
        { updateOn: 'submit' }
      )
    );
  }

  saveAddress(i: number, address: FormGroup) {
    const companyData = address.getRawValue() as CustomerCompanyData;

    // update
    if(companyData.id) {
      this.companyService.updateCompanyData(this.customerId, companyData).subscribe(res => {
        // console.log(res);
      });
      return;
    }

    // add
    delete companyData.id;
    delete companyData.row_num;
    this.companyService.addCompanyData(+this.customerId, companyData).subscribe(res => {
      address.get('id').setValue(res.id);
    });
  }

  deleteAddress(i: number, address: FormGroup) {
    if(!address.get('id').value) {
      this.addresses.removeAt(i);
      return;
    }

    this.companyService.deleteCompanyData(this.customerId, address.get('id').value).subscribe(res => {
      this.addresses.removeAt(i);
    });
  }

  save() {
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-company/customer-company-address/customer-company-address.component.ts